var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stroke_Line/Download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0304 9.5331V17.5M10.0304 17.5L12.8315 14.6882M10.0304 17.5L7.22935 14.6882M6.29566 5.34908C6.99434 5.44937 7.64158 5.77506 8.13971 6.27699M15.1658 11.8763C16.584 11.8763 17.5 10.7225 17.5 9.29878C17.5 8.73512 17.3158 8.18701 16.9759 7.73841C16.6359 7.2898 16.1588 6.96544 15.6177 6.81499C15.5344 5.76379 15.1004 4.7715 14.3858 3.99854C13.6713 3.22559 12.7179 2.71716 11.6798 2.55544C10.6418 2.39373 9.57971 2.58818 8.66537 3.10737C7.75103 3.62656 7.03785 4.44014 6.64113 5.41656C5.80587 5.18414 4.91284 5.29431 4.1585 5.72285C3.40416 6.15139 2.8503 6.86319 2.61877 7.70166C2.38723 8.54012 2.49699 9.43658 2.92388 10.1938C3.35078 10.9511 4.05986 11.507 4.89512 11.7395",
    stroke: "#005C5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.b5bf94b50c4c032493fb1aaa724de0a7.svg";
export { ForwardRef as ReactComponent };